<!-- 降级规则设置（由 behavior_level 的等级规则表单复制而来，独立维护） -->
<template>
  <div class="upgrade_rules">
    <el-form :model="form" ref="form" label-width="160px">
      <el-form-item label="启用等级降级规则：">
        <!-- <el-switch v-model="isStart" @change="isChangeSwitch"> </el-switch> -->
        <el-switch v-model="form.downIsOpen" :active-value="1" :inactive-value="0"> </el-switch>
      </el-form-item>
      <el-form-item label="等级有效期：">
        <el-radio-group
          v-model="form.downTimeType"
          class="valid-date"
          @change="changeGradeValidDate"
        >
          <el-radio :label="3">永久有效</el-radio>
          <el-radio :label="4">等级有效期至</el-radio>
          <span class="valid-inline">
            <el-input
              v-model="form.gradeValidNum"
              class="valid-num"
              placeholder="请输入内容"
              @focus="form.downTimeType = 4"
              @input="handleGradeValidNumInput"
              @blur="handleGradeValidNumBlur"
            ></el-input>
            <el-select
              v-model="form.gradeValidUnit"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.downTimeType = 4"
            >
              <el-option label="年" value="year"></el-option>
              <el-option label="月" value="month"></el-option>
              <el-option label="日" value="day"></el-option>
            </el-select>
            <span class="valid-text">后失效</span>
          </span>
          <el-radio :label="2">等级有效期至</el-radio>
          <span class="valid-inline">
            <el-input
              v-model="form.gradeValidYearNum"
              class="valid-num"
              placeholder="请输入内容"
              @focus="form.downTimeType = 2"
              @input="handleGradeValidYearNumInput"
              @blur="handleGradeValidYearNumBlur"
            ></el-input>
            <span class="valid-text">年后的</span>
            <el-select
              v-model="form.gradeValidMonth"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.downTimeType = 2"
              @change="handleGradeValidMonthChange"
            >
              <el-option
                v-for="m in monthOptions"
                :key="m"
                :label="m"
                :value="m"
              ></el-option>
            </el-select>
            <span class="valid-text">月</span>
            <el-select
              v-model="form.gradeValidDay"
              class="valid-unit"
              placeholder="请选择"
              @focus="form.downTimeType = 2"
            >
              <el-option
                v-for="d in dayOptions"
                :key="d"
                :label="d"
                :value="d"
              ></el-option>
            </el-select>
            <span class="valid-text">日失效</span>
          </span>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="等级设置：">
        <!-- 表格 -->
        <y-table
          :tableInfo="tableInfo"
          :tableData="form.gradeDetailList"
          :autoMaxHeight="false"
        >
          <template #gradeName="scope">
            <div class="tableCont">{{ scope.row.gradeName }}</div>
          </template>

          <template #gradeRule="scope">
            <div v-if="scope.rowIndex == 0" class="tableCont">
              最低等级，无需设置降级规则
            </div>
            <div class="rule-list" v-else>
              <div class="rule-line">
                <span class="rule-label">到期降级为</span>
                <el-select
                  v-model="scope.row.downToLevel"
                  class="rule-select"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lowerGradeList(scope.rowIndex)"
                    :key="item.gradeCode"
                    :label="item.gradeName"
                    :value="item.gradeCode"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </template>
        </y-table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { upRuleSwitch, ruleSave } from "@/api/manage/scoreList";
export default {
  components: {
  },
  props: {
    upRuleType: {
      default: "",
    },
  },
  data() {
    return {
      isStart: false, //是否启用规则
      _upRuleType: "",
      form: {
        downIsOpen: 0, // 是否启用降级规则
        behaviorLevelCalcRule: 0,
        gradeDetailList: [],
        // 等级有效期：1 永久有效、2 数值+单位后失效、3 数值年后的指定时间失效
        downTimeType: 3,
        gradeValidNum: "", // 方式2的数值：1-999 的正整数
        gradeValidUnit: "year", // year / month / day
        gradeValidYearNum: "", // 方式3的数值：1-999 的正整数
        gradeValidMonth: "", // 方式3的月份
        gradeValidDay: "", // 方式3的日期
        gradeUpgradeRule: 1, // 保级不成功设置（随表单一起提交）
      },
      // 方式3：月 / 日 下拉选项（日期部分见 computed.dayOptions，随月份变化）
      monthOptions: Array.from({ length: 12 }, (v, i) => i + 1),
      loading: false,
      goodsState: false, // 选择商品弹窗
      goodsPostForm: [], // 已选商品数据---弹窗用
      selectGoodsList: [], // 已选商品列表--指定商品
      selectGoodsList2: [], // 已选商品列表--排除特定商品
      selectGoodsType: 1, // 用于储存当前打开的弹窗类型，因公用一个组件，以此区分
      selectGoodsIndex: 1, // 用于储存当前选择商品的下标
      // 新建升级规则弹窗
      upgradeRulesVisible: false,
      upgradeRuleRow: {},
      upgradeRuleIndex: null, // null 新建，数字为编辑下标
      upgradeRuleData: null, // 编辑时回显的规则
      tableInfo: [
        {
          label: "等级名称",
          prop: "gradeName",
          slot: "gradeName",
          align: "center",
          width: "400px",
        },
        {
          label: "规则",
          align: "center",
          prop: "gradeName",
          slot: "gradeRule",
        },
      ],
      removeVisible: false, // 移除黑名单弹窗
      removeRow: {}, // 移除黑名单弹窗数据
      removeIndex: 0, // 移除黑名单弹窗下标
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    // 详情数据由父级（behavior_level）统一请求后通过 initDetail 传入
    //判断开启状态
    this._upRuleType = this.upRuleType;
    if (this._upRuleType == 1) {
      this.isStart = true;
    }
  },
  computed: {
    // 方式3的日期选项：2 月只有 1-28，其余月份 1-31
    dayOptions() {
      const max = Number(this.form.gradeValidMonth) === 2 ? 28 : 31;
      return Array.from({ length: max }, (v, i) => i + 1);
    },
  },
  methods: {
    // 校验（父级点保存时统一调用，校验不通过自行提示）
    validate() {
      // 除最低等级外，每个等级都要选到期降级的目标等级
      const gradeList = this.form.gradeDetailList || [];
      for (let i = 1; i < gradeList.length; i++) {
        if (!gradeList[i].downToLevel) {
          this.$message.warning(
            "【降级规则】请为" +
              gradeList[i].gradeName +
              "等级选择到期降级的目标等级!"
          );
          return false;
        }
      }
      return true;
    },
    // 保存
    save() {
      if (!this.validate()) return;
      this.form.scoresCardId = this.MemberSystemInfo.scoresCardId;
      const payload = JSON.parse(JSON.stringify(this.form));
      // 最低等级不需要降级规则，提交时去掉
      payload.gradeDetailList = (payload.gradeDetailList || [])
        .map((item) => ({
          // 保留等级标识，父级按等级合并三个 tab 的数据时要用
          gradeName: item.gradeName,
          scoresMemberGradeId: item.scoresMemberGradeId,
          gradeCode: item.gradeCode,
          downToLevel: item.downToLevel,
        }));
      // 返回组装好的 form 数据，由父级统一合并提交
      return payload;
    },
    // 降级目标：只能选比当前等级更低的等级（gradeDetailList 第一个是末等级）
    lowerGradeList(rowIndex) {
      return (this.form.gradeDetailList || []).slice(0, rowIndex);
    },
    changeGradeValidDate(val) {
      // 切到「数值+单位」时，单位没选过就给个默认值
      if (val === 2 && !this.form.gradeValidUnit) {
        this.form.gradeValidUnit = "year";
      }
    },
    // 等级有效期数值：只允许正整数，最大 999
    normalizeGradeValidNum(val) {
      let num = String(val === null || val === undefined ? "" : val).replace(
        /\D/g,
        ""
      );
      if (num && Number(num) > 999) {
        num = "999";
      }
      return num;
    },
    // 失焦时兜底最小值
    fixGradeValidNum(num) {
      if (num === "" || num === null || num === undefined) return "";
      return Number(num) < 1 ? "1" : String(num);
    },
    // 方式2：N 年/月/日 后失效
    handleGradeValidNumInput(val) {
      this.form.gradeValidNum = this.normalizeGradeValidNum(val);
    },
    handleGradeValidNumBlur() {
      this.form.gradeValidNum = this.fixGradeValidNum(this.form.gradeValidNum);
    },
    // 方式3：月份变化后，已选日期超出当月天数则清空，避免出现「2月31日」
    handleGradeValidMonthChange(val) {
      this.form.downTimeType = 2;
      const max = Number(val) === 2 ? 28 : 31;
      if (this.form.gradeValidDay && Number(this.form.gradeValidDay) > max) {
        this.form.gradeValidDay = "";
      }
    },
    // 方式3：N 年后的指定时间失效（独立字段，互不影响）
    handleGradeValidYearNumInput(val) {
      this.form.gradeValidYearNum = this.normalizeGradeValidNum(val);
    },
    handleGradeValidYearNumBlur() {
      this.form.gradeValidYearNum = this.fixGradeValidNum(
        this.form.gradeValidYearNum
      );
    },
    // 回显：详情数据由父级统一请求后传入，本组件不再单独调接口
    initDetail(data) {
      if (!data) return;
      const res = { data };
      // 接口未返回等级有效期相关字段时，用默认值兜底
        this.form = Object.assign(
          {
            downIsOpen: 0, // 是否启用降级规则
            downTimeType: 3,
            gradeValidNum: "",
            gradeValidUnit: "year",
            gradeValidYearNum: "",
            gradeValidMonth: "",
            gradeValidDay: "",
          },
          res.data
        );
        if (!this.form.downTimeType) {
          this.form.downTimeType = 3;
        }
        if (!this.form.gradeValidUnit) {
          this.form.gradeValidUnit = "year";
        }
        (this.form.gradeDetailList || []).forEach((item) => {
          item.specificItems = [];
          item.excludeItems = [];
          // 降级目标等级：后端未返回时初始化为空，保证下拉可双向绑定
          if (!item.downToLevel) {
            this.$set(item, "downToLevel", "");
          }
          if (
            item.itemSelectType == 1 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods) => {
              item.specificItems.push({
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              });
            });
          } else if (
            item.itemSelectType == 2 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods) => {
              item.excludeItems.push({
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              });
            });
          } else {
            item.specificItems = [];
            item.excludeItems = [];
          }
        });
    },
    //改变启用状态
    isChangeSwitch() {
      let newType = this.isStart;
      this.isStart = false;
      if (this._upRuleType == 2) {
        this.isStart = false;
        this.$message.warning("启用失败: 启用行为等级规则需关闭成长值等级规则");
      } else {
        let params = {
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
          upRuleType: 1,
          state: newType,
        };
        upRuleSwitch(params)
          .then((res) => {
            if (res.code == 200) {
              if (newType) {
                this.isStart = true;
                this._upRuleType = 1;
                this.$message.warning("启用成功");
              } else {
                this.isStart = false;
                this.$message.warning("修改成功");
                this._upRuleType = "";
              }
              this.$emit("changeUpRuleType", this._upRuleType);
            } else {
              this.isStart = false;
            }
          })
          .catch(() => {
            this.isStart = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade_rules {
  height: 100%;
}
/deep/ .el-input__prefix {
  left: 3px !important;
}
// 降级规则列：到期降级目标
.rule-list {
  width: 100%;
}

.rule-line {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
}

.rule-label {
  font-size: 14px;
  color: #606266;
  margin-right: 12px;
}

.rule-select {
  width: 180px;
}

.tableCont {
  width: 100%;
  text-align: center;
  padding: 0px 10px;
  .select_btn {
    color: $theme-color;
    margin-left: 12px;
    cursor: pointer;

    span {
      margin: 0 5px;
    }
  }
}

.inline_input {
  width: 100px;
  margin: 0 8px;
}
:deep(.el-table td .cell) {
  padding: 0px !important;
}

// 等级有效期：单选项与内嵌输入框同一行排列
// 注意：element-ui 的 .el-radio-group 自带 font-size: 0，这里必须显式恢复字号，
// 否则组内平铺的「后失效 / 年后的 / 失效」等文字会因字号为 0 而不可见
.valid-date {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 22px;

  .el-radio {
    margin-right: 12px;
  }
  .valid-inline {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
  }
  .valid-num {
    width: 110px;
  }
  .valid-unit {
    width: 90px;
    margin-left: 8px;
  }
  // 前面已有文字时（如「年后的 [月] 月」），间距交给文字自身的 margin，避免叠加
  .valid-text + .valid-unit {
    margin-left: 0;
  }
  .valid-text {
    margin: 0 8px;
    color: #606266;
  }
}
</style>
